"use client";

import React from "react";
import GenericLazyLoader from "@/components/common/generic-lazy-loader";

interface LazyLoadAccommodationsProps {
  packageId: string;
  packageDateId: string;
  neoId: string;
}

const LazyLoadAccommodationsSection = ({
  packageId,
  packageDateId,
  neoId
}: LazyLoadAccommodationsProps) => (
  <GenericLazyLoader
    importComponent={() => import("../accommodations/accommodations")}
    componentProps={{ packageId, packageDateId, neoId, sectionId: null }}
    debugName="Accommodations Section"
    threshold={0.1}
    rootMargin="200px 0px"
    wrapperProps={{ id: "accommodations", className: "anchor-section" }}
  />
);

export default LazyLoadAccommodationsSection;